import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { CROP_VIRTUAL_PRODUCT_TYPE } from 'appConstants';
import type { IGenericObject } from 'types';
import { getCropProductQuantity, getCropProductTypeLabel } from 'utils';

export default function useOrderDetailsCrop(transNamespace: string, isSummary?: boolean) {
  const { t } = useTranslation(transNamespace, { keyPrefix: 'OrderSummary' });

  return useMemo(
    () => [
      {
        fields: [
          {
            label: t('fields.productType'),
            accessor: 'productType',
            displayValue: (value) => getCropProductTypeLabel(value),
          },
          {
            label: t('fields.referenceCode'),
            accessor: 'packagedItemReference',
          },
        ],
      },
      {
        fields: [
          {
            label: t('fields.packSize'),
            accessor: `${isSummary ? 'productData.' : ''}packageDescription`,
            hidden: ({ productType }: IGenericObject) => productType === CROP_VIRTUAL_PRODUCT_TYPE,
          },
          {
            label: t('fields.packNumber'),
            accessor: 'packagedItemQty',
          },
          {
            label: t('fields.quantity'),
            accessor: 'quantity',
            displayValue: (value, data: IGenericObject) => {
              const quantity =
                value === null || value === undefined || value === ''
                  ? getCropProductQuantity(data)
                  : Number(value);

              return Number.isFinite(quantity) ? quantity : '-';
            },
          },
        ],
      },
    ],
    [isSummary, t],
  );
}
